<template>
  <div class="navbar-timezone-clocks">
    <div class="time-item">
      <span class="label">本地</span>
      <span class="time">{{ localTime }}</span>
    </div>
    <div class="time-item">
      <span class="label">{{ countryCnName }}</span>
      <span class="time">{{ lagosTime }}</span>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import config from '@/config'

const localTime = ref('')
const lagosTime = ref('')

console.log('config', config)

const countryCnName = config.countryCnName
const TZ_LAGOS = config.timeZone

function formatLocalNow(date) {
  return new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(date)
}

function formatNow(date, timeZone) {
  return new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone,
  }).format(date)
}

function tick() {
  const now = new Date()
  localTime.value = formatLocalNow(now)
  lagosTime.value = formatNow(now, TZ_LAGOS)
}

let timerId = null

onMounted(() => {
  tick()
  timerId = window.setInterval(tick, 1000)
})

onBeforeUnmount(() => {
  if (timerId != null) {
    clearInterval(timerId)
    timerId = null
  }
})
</script>

<style lang="scss" scoped>
.navbar-timezone-clocks {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 8px;
  margin-right: 4px;
  height: 50px;
  overflow: hidden;
}

.time-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  line-height: 20px;
  height: 20px;
}

.time-item:first-child {
  color: #1890ff;
}

.time-item:last-child {
  color: #67c23a;
}

.label {
  margin-right: 8px;
  font-weight: 600;
  min-width: 52px;
}

.time {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}
</style>
